import React from "react";
import { Link } from "react-router-dom";
import line from "../assets/line.png";

const SolutionSection = () => {
  const offerings = [
    {
      title: "HIS",
      desc: "Comprehensive hospital management for streamlined operations.",
      link: "/his",
    },
    {
      title: "EHR",
      desc: "Electronic health records for better patient data management.",
      link: "/ehr",
    },
    {
      title: "RCM",
      desc: "Revenue cycle management for optimized healthcare finances.",
      link: "/rcm",
    },
    {
      title: "LIMS",
      desc: "Laboratory information management for faster results.",
      link: "/lims",
    },
  ];

  return (
    <div className="mt-8 sm:mt-10 px-4 sm:px-6 lg:px-0">
      {/* Heading */}
      <div className="mb-6 text-left">
        <div className="relative inline-block pb-2">
          <span className="relative z-10 text-xl sm:text-2xl md:text-3xl">
            <span className="text-[#00cfff] font-bold">WISE</span>{" "}
            <span className="text-black font-bold">Product Offerings</span>
          </span>
          <img
            src={line}
            alt="underline"
            className="absolute left-0 bottom-0 h-[4px] sm:h-[6px] w-full object-contain"
          />
        </div>
      </div>

     {/* Grid */}
<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
  {offerings.map((item, i) => (
    <div
      key={i}
      className="group p-4 sm:p-6 rounded-lg shadow border border-purple-600 bg-white 
                 hover:bg-[#4B0EA6] hover:-translate-y-2 hover:shadow-xl 
                 transition-all duration-500"
    >
      <h3 className="font-bold mb-2 text-left text-lg sm:text-xl text-black group-hover:text-white transition-colors duration-300">
        WISE -{" "}
        <span className="text-[#0077cc] group-hover:text-white transition-colors duration-300">
          {item.title}
        </span>
      </h3>

      <p className="text-sm sm:text-base mb-4 text-gray-700 group-hover:text-white transition-colors duration-300">
        {item.desc}
      </p>

      <Link
        to={item.link}
        className="inline-block mt-3 px-3 sm:px-4 py-2 border-2 rounded-lg font-semibold text-sm sm:text-base 
                   transition-all duration-300 hover:shadow-md 
                   text-[#0077cc] border-[#0077cc] group-hover:text-white group-hover:border-white"
      >
        Know More
      </Link>
    </div>
        ))}
      </div>
    </div>
  );
};

export default SolutionSection;
